import styled from '@emotion/styled'

const StyledDiv = styled.div`
  max-width: ${(props) => props.theme.widths[0]};
  margin: 0 auto;
  line-height: 1.67;
  &:last-child {
    margin-bottom: 6rem;
  }
  p {
    margin: 1rem 0;
  }
  h1 {
    font-family: ${(props) => props.theme.fonts.title};
    font-size: ${(props) => props.theme.fontSizes[6]};
    margin-top: ${(props) => (props.top ? '4rem' : '3rem')};
    line-height: 1.5;
  }
  h2 {
    font-family: ${(props) => props.theme.fonts.title};
    font-size: ${(props) => props.theme.fontSizes[5]};
    margin-top: 2rem;
  }
  a {
    color: ${(props) => props.theme.colors.orange};
  }
`

const Text = ({ text, top }) => {
  return <StyledDiv top={top} dangerouslySetInnerHTML={{ __html: text }} />
}

export default Text
